import Heading from "@/components/tpr/Heading/Heading";

// import { Item, ItemActions, ItemContent, ItemDescription, ItemTitle } from "@/components/ui/item";
// import { useMember } from "@/contexts/memberContext";

const CookiesPolicyView = () => {
  // const { member } = useMember();
  return (
    <div>
      <div className="px-4 min-h-[80vh]">
        <div className="mb-8 mt-8">
          <Heading title={`Cookies Policy`} />
        </div>

        <section className="text-gray-600 body-font pt-4 pb-1">
          <div className="container px-5 mt-4 mb-8 mx-auto flex flex-wrap">
            <a
              href="/terms"
              className="flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium bg-indigo-800 text-white hover:cursor-pointer"
            >
              👈 See all our terms &amp; conditions
            </a>
          </div>
        </section>

        <div className="container px-5 py-12 mx-auto flex flex-wrap text-gray-600 body-font">
          <div className="text-base">
            <p className="mb-4">
              We ("The Practice Rooms") use small files (known as, Cookie, Cookies) to see how you use our site and
              products. We put them on your computer when you visit our site. We use them to know it&apos;s you and
              store information about your visits. With Cookies we can give you a better browsing experience, make our
              products better, and keep our marketing costs down. They make it easier to log in, and they show us where
              you might need help with our products.
            </p>
            <p className="mb-4">Below, we&apos;ve explained how and why we use Cookies, and what each of them do:</p>

            <ul className="ml-8 list-disc">
              <li>
                <span className="font-bold">Strictly Necessary or Essential Cookies</span> are there for our website to
                work. They let us save your cookie choice , and keep the site secure. They&apos;re always on.
              </li>
              <li>
                <span className="font-bold">Functional Cookies</span> give you a better browsing experience. These
                Cookies let us make the site suit your needs, like showing it in the same language as your web browser.
              </li>
              <li>
                <span className="font-bold">Analytical or Performance Cookies</span> help us make our products better.
                These let us use tools that show us how you use our products. They help us find and fix problems for our
                customers.
              </li>
              <li>
                <span className="font-bold">Cookies that keep our marketing costs down.</span> These make our marketing
                better — helping us to spend less on sites like Google and Facebook, and more on charging as little as
                we can. When our costs go down, so do our prices. We share this information in aggregate form with third
                parties, for the purpose of advertising.
              </li>
            </ul>

            <h3 className="font-abeezee text-2xl font-bold mt-8">How to block Cookies</h3>
            <p className="mb-4">
              You can choose to block all or some Cookies, to do this you should go to your browser settings. However,
              if you block all Cookies (including essential Cookies) you may not be able to use some of the site. Your
              browser settings also allow you to delete all Cookies stored on your device any time you wish.
            </p>

            <h3 className="font-abeezee text-2xl font-bold mt-8">How to control Cookies</h3>
            <p className="mb-4">
              The{" "}
              <a
                className="ml-1 text-indigo-500"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.ico.org.uk/"
              >
                UK Information Commissioner&apos;s Office
              </a>{" "}
              has provided the following guidance on Cookies:
            </p>

            <ol className="mt-4 ml-8 space-y-1 text-gray-500 list-disc list-inside dark:text-gray-400">
              <li>
                You can read information on Cookies on different websites, including{" "}
                <a
                  href="https://aboutcookies.org/"
                  className="ml-1 text-indigo-500"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  AboutCookies.org
                </a>{" "}
                and{" "}
                <a
                  href="https://allaboutcookies.org/"
                  className="ml-1 text-indigo-500"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  AllAboutCookies.org
                </a>
                .
              </li>
              <li>
                The{" "}
                <a href="https://edaa.eu/" className="ml-1 text-indigo-500" target="_blank" rel="noopener noreferrer">
                  European Interactive Digital Advertising Alliance
                </a>{" "}
                website &apos;Your Online Choices&apos;: allows you to install an add-on to decline Cookies across
                different advertising networks. Google has developed a browser add-on to allow users to decline Google
                Analytics on all websites which use it. This is also available in the{" "}
                <a
                  href="https://chromewebstore.google.com/"
                  className="ml-1 text-indigo-500"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Chrome web store
                </a>
                .
              </li>
              <li>
                Some browsers include a feature known as "Do Not Track" or DNT. This allows you to choose whether a
                website can track you. However, whilst DNT is available in many browsers, websites do not need to
                recognise this request, so it may not always work. You can get help on how to use DNT in{" "}
                <a
                  href="https://www.microsoft.com/en-us/edge/?form=MA13FJ"
                  className="ml-1 text-indigo-500"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Microsoft Edge
                </a>
                ,{" "}
                <a
                  href="https://www.mozilla.org/en-GB/firefox/new/"
                  className="ml-1 text-indigo-500"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Mozilla Firefox
                </a>
                ,{" "}
                <a
                  href="https://www.google.com/intl/en_uk/chrome/"
                  className="ml-1 text-indigo-500"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Google Chrome
                </a>{" "}
                and{" "}
                <a
                  href="https://www.opera.com/"
                  className="ml-1 text-indigo-500"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Opera
                </a>
                .
              </li>
              <li>
                For more information on how browsing works, visit the support pages for your browser:{" "}
                <a
                  href="https://www.microsoft.com/en-us/edge/?form=MA13FJ"
                  className="ml-1 text-indigo-500"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Microsoft Edge
                </a>
                ,
                <a
                  href="https://www.mozilla.org/en-GB/firefox/new/"
                  className="ml-1 text-indigo-500"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Mozilla Firefox
                </a>
                ,
                <a
                  href="https://www.google.com/intl/en_uk/chrome/"
                  className="ml-1 text-indigo-500"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Google Chrome
                </a>
                ,{" "}
                <a
                  href="https://www.opera.com/"
                  className="ml-1 text-indigo-500"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Opera
                </a>{" "}
                and
                <a
                  href="https://www.apple.com/uk/safari/"
                  className="ml-1 text-indigo-500"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Safari
                </a>
              </li>
            </ol>

            <p className="mb-4 mt-4">
              If you worry about online tracking you can: Install a privacy-friendly browser on your device, such as
              Mozilla Firefox, Firefox Focus or Brave; Install anti-tracking and ad-blocking plug-ins on that browser,
              such as uBlock, Ghostery or PrivacyBadger; and Use privacy-friendly web search engines, such as DuckDuckGo
              or Qwant.
            </p>
            <p className="mb-4">
              If you have any questions about the Cookies or similar technologies in use on our website, please contact
              us.
            </p>
            <p className="mb-4">
              You can view and manage the cookies we use on our website using our{" "}
              <a href="/cookie-settings" className="text-indigo-500">
                Cookie Settings
              </a>{" "}
              page.
            </p>

            <p className="mb-4">
              The table below contains technical descriptions for each of the Cookies we use and our reasons for using
              them:
            </p>

            <table className="table-auto md:table-fixed w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
                <tr>
                  <th className="py-4" scope="col">
                    <span className="font-bold">Technology</span>
                  </th>
                  <th scope="col">
                    <span className="font-bold">Purpose</span>
                  </th>
                  <th scope="col">
                    <span className="font-bold">Type</span>
                  </th>
                  <th scope="col">
                    <span className="font-bold">Lifespan</span>
                  </th>
                  <th scope="col">
                    <span className="font-bold">Further information</span>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td className="py-4 bg-indigo-50" colSpan={5}>
                    <p className="font-bold text-center">Strictly Necessary Cookies</p>
                  </td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="text-center py-8" colSpan={5}>
                    None
                  </td>
                </tr>

                <tr>
                  <td className="py-4 bg-indigo-50" colSpan={5}>
                    <p className="font-bold text-center">Analytical or Performance Cookies</p>
                  </td>
                </tr>
                <tr className="border-b  border-gray-200">
                  <th scope="row" className="py-4 vertical-align-top">
                    <span className="font-bold">Google</span>
                  </th>
                  <td className="py-4 vertical-align-top">
                    We use the Google Analytics{" "}
                    <span className="font-mono bg-gray-100 px-1 rounded-md">
                      _ga, _gat, _gid, APISID, DSID, HSID, IDE, NID, SAPISID, SID, SSID, _gfp_s_64b, __Secure-1PAPISID,
                      __Secure-1PSID, Secure-3PAPISID, Secure-3PSID, ar_debug
                    </span>{" "}
                    cookies to help us receive analytical information on how visitors and customers use our site and
                    products. This cookie helps us uniquely identify visitors so that new features on the site are
                    consistently displayed each time they visit. Without this use, new features will not function
                    correctly. If you consent to the cookie banner, we might share some information with third parties.
                  </td>
                  <td>Persistent</td>
                  <td>1 year</td>
                  <td>
                    <a
                      href="https://policies.google.com/privacy?hl=en-GB"
                      className="ml-1 text-indigo-500"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://policies.google.com/privacy?hl=en-GB
                    </a>
                  </td>
                </tr>
                <tr className="border-b  border-gray-200">
                  <th scope="row" className="py-4 vertical-align-top">
                    <span className="font-bold">The Practice Rooms</span>
                  </th>
                  <td className="py-4 vertical-align-top">
                    We use a consent cookie to remember your cookie preferences. If you choose not to accept cookies,
                    the consent window will ask your preference on every visit.
                  </td>
                  <td>Persistent</td>
                  <td>1 year</td>
                  <td>&nbsp;</td>
                </tr>
                <tr className="border-b  border-gray-200">
                  <th scope="row" className="py-4 vertical-align-top">
                    <span className="font-bold">The Practice Rooms</span>
                  </th>
                  <td className="py-4 vertical-align-top">
                    We use cookies to enable you to login and use our booking system. We use session cookies and
                    persistent cookies to save the state of the application during your use.
                  </td>
                  <td>Persistent</td>
                  <td>1 year</td>
                  <td>&nbsp;</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiesPolicyView;
